var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.277,
    height: 162.394,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{fill:none}.C{clip-rule:evenodd}.D{fill:#0057ff}.E{clip-path:url(#D)}.F{stroke-linecap:round}.G{stroke-linejoin:round}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h161.901v109.624H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.995-932h143.912c4.967 0 8.994 3.414 8.994 7.626V-830c0 4.212-4.027 7.626-8.994 7.626H611.995c-4.968 0-8.995-3.414-8.995-7.626v-94.372c0-4.214 4.027-7.628 8.995-7.628z",
    transform: "translate(-603 932)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h183.672v109.624H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603-822.376H764.9V-932H603Z",
    transform: "translate(-603 932)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603-893.87H786.622V-932H603Z",
    transform: "translate(-603 932)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M674-799.523H779.123V-800H674Z",
    transform: "translate(-674 800)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.124-825h16.865a1.05 1.05 0 0 1 1.124.953 1.05 1.05 0 0 1-1.124.953h-16.865a1.05 1.05 0 0 1-1.124-.953 1.05 1.05 0 0 1 1.124-.953z",
    transform: "translate(-623 825)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h17.433v14.781H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "I",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAc5JREFUWIW9VltyxCAME2zu2Pvfo9n0p+7KQgaSj3rGkxe2hDDBDV8XNqztDDK2TH48AF6RYdBm3m0RUJBWXB14I8C4lkQcAQfODrln8Ku451yJhBJo5r4LgY5RCQZ7E4F45jGJBBNQcAXs5KqIAoarCgOJagkYvAN4yZVVCGPwk64gFZhEUsCtewCqqwqsQBDov+BNSAz14GqApQ7Qw5CoCJzyTWediBzIBcXO4OE7S+C+B0El3ZwCuvaqwIyAmzkT0//EsAuYgFt/J/+MQMjNOyPGpF3AQR1jHei76hetP6IX8rJ0fHZEA3D1QgEtRlf5znZiU45eJJj5ym7lUAKchJM9NT0/BqsI/JtVBNyp9sSqU7EkcG34LuhWjj4JfBtfkdiJTTkOCowi0cAT4xacNSQaq/l4fPoT6uwZWJXaOY7VVYWkQDWL6mS7sCbwLeB2CQ9KppUf4AqwcxyHMwlXA0M/wD0c8GkmFGTVkDj5tU37UyASuNm65HdbMgscz64n1O4l3sVJdrcptcUXprvAtdnAp0aYAIrxq7Y83bsa0KTcRDR51lgtZDdrWwMVCQ7g99UJqcpNwSsCPNBJnHq6Sezq3ZRARWSa7A5w2A902ySbBZh6SgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634-819.748h17.989V-835H634Z",
    transform: "translate(-634 835)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.145-824.71c2.289 0 4.145-1.856 4.145-4.145S646.434-833 644.145-833 640-831.144 640-828.855s1.856 4.145 4.145 4.145z",
    transform: "translate(-640 833)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603-836.664H722.377V-932H603Z",
    transform: "translate(-603 932)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M674-751.523H779.123V-752H674Z",
    transform: "translate(-674 752)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M820.177-913h11.216a5.47 5.47 0 0 1 5.177 5.719 5.47 5.47 0 0 1-5.177 5.72h-11.216A5.47 5.47 0 0 1 815-907.28a5.47 5.47 0 0 1 5.177-5.72z",
    transform: "translate(-815 913)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603-822.376H727.239V-932H603Z",
    transform: "translate(-603 932)",
    className: "B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "M45.138 48.57h52c1.1 0 2 .466 2 1.04v4.16c0 .575-.9 1.04-2 1.04h-52c-1.1 0-2-.466-2-1.04v-4.16c0-.574.9-1.04 2-1.04z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-995.723 -703)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162.022,
    height: 39.38,
    rx: 19.69,
    fill: "#edeff2",
    x: 995.723,
    y: 826.014
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.671 865.027c-2.075.002-4.136-.328-6.107-.976h122.22a19.48 19.48 0 0 1-6.108.976z",
    fill: "#d4d9dd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255,255,255,0)",
    d: "M1126.241 833.89h23.628v23.628h-23.628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.529 850.929v-4.822h-4.822c-.533 0-.964-.432-.964-.965s.432-.964.964-.964h4.822v-4.822c0-.533.432-.965.965-.965s.964.432.964.965v4.822h4.822c.533 0 .965.432.965.964s-.432.965-.965.965h-4.822v4.822c0 .533-.432.965-.964.965s-.965-.432-.965-.965z",
    className: "D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(996.099 703)",
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-431.348 -677.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.348 677.2)",
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.562-.477h163.025V110.1H-.562z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.562-.477h163.025v39.083H-.562z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.913 62.915)",
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.562.953h106.248v-1.43H-.562z",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.243 50.999)",
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.243 -50.999)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.681 50.522h20.238v2.86H10.681z",
    fill: "#eceff1"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.434 46.806)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M0 0h17.433v14.781H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.427 46.233)",
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.973 10.486c3.1 0 5.622-2.134 5.622-4.766S48.077.953 44.973.953s-5.622 2.134-5.622 4.766 2.517 4.767 5.622 4.767z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.726 46.854)",
    clipPath: "url(#K)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.337 -41.036)",
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.922 40.621h9.119v9.119h-9.119z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.913 85.793)",
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.562.953h106.248v-1.43H-.562z",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.848 9.056)",
    clipPath: "url(#N)",
    className: "B"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.454 -9.056)",
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.631 9.056h11.216a5.47 5.47 0 0 1 5.177 5.72 5.47 5.47 0 0 1-5.177 5.72H96.631a5.47 5.47 0 0 1-5.177-5.72 5.47 5.47 0 0 1 5.177-5.72z",
    stroke: "#f9f9fa"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.016 8.8h74.841c1.59 0 2.878.9 2.878 2v8c0 1.1-1.289 2-2.878 2H16.016c-1.589 0-2.878-.9-2.878-2v-8c0-1.1 1.289-2 2.878-2zm-.878 17h52c1.1 0 2 .466 2 1.04V31c0 .575-.9 1.04-2 1.04h-52c-1.1 0-2-.466-2-1.04v-4.16c0-.574.9-1.04 2-1.04z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#a2a6a9"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.138 71.569h52c1.1 0 2 .466 2 1.04v4.16c0 .575-.9 1.04-2 1.04h-52c-1.1 0-2-.466-2-1.04v-4.16c0-.574.9-1.04 2-1.04zm0 22h52c1.1 0 2 .466 2 1.04v4.16c0 .575-.9 1.04-2 1.04h-52c-1.1 0-2-.466-2-1.04v-4.16c0-.574.9-1.04 2-1.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#a2a6a9",
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.551 76.504v.928a.93.93 0 0 0 .928.928h5.572a.93.93 0 0 0 .928-.928V76.04",
    opacity: 0.5,
    className: "F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.871 72.244v-1.771l4.031 2.952-4.031 2.948v-1.767c-1.6 0-3.067.059-4.32 2.362 0-1.461.144-4.724 4.32-4.724z",
    className: "G"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "B F G"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#a2a6a9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.484 91.939h8.051m-5.574-.427v-.619a.6.6 0 0 1 .604-.589h1.889a.6.6 0 0 1 .6.589v.619m-4.664.931l.449 6.38a.73.73 0 0 0 .759.664h3.934a.73.73 0 0 0 .757-.664l.343-4.876"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(162,166,169,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.503 94.204v3.019m2.013-3.019v3.019"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp11);
export default __webpack_public_path__ + "static/media/scrumlr-lp-11.01bdf68e0fe2f3cc5778c25d9e3952af.svg";
export { ForwardRef as ReactComponent };